import React from "react";
import { Link } from "react-router-dom";
import { MEDIA } from "@/lib/media";
import { Reveal } from "@/components/Reveal";

const VALUES = [
  { k: "Precision", d: "Post spacing, infill gaps, and rail heights held to code and to the millimeter." },
  { k: "Engineering", d: "In-house detailing and load calculations on every railing run." },
  { k: "Craftsmanship", d: "Clean welds, flawless glass, and finishes that read as a single line." },
  { k: "Trust", d: "Transparent proposals and disciplined installs, project after project." },
];

const STATS = [
  { n: "15+", l: "Years in architectural railings" },
  { n: "900+", l: "Railing runs installed" },
  { n: "62mi", l: "Of handrail delivered" },
  { n: "100%", l: "Self-performed installs" },
];

export default function About() {
  return (
    <div>
      <section className="relative h-[70vh] overflow-hidden bg-onyx-black" data-testid="about-hero">
        <img src={MEDIA.panelStair} alt="" className="absolute inset-0 w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-black/20" />
        <div className="relative h-full max-w-[1600px] mx-auto px-6 lg:px-12 flex flex-col justify-end pb-20">
          <span className="text-onyx-wood text-[11px] tracking-[0.35em] uppercase mb-5">About ONYX</span>
          <h1 className="text-white font-display font-extrabold text-5xl md:text-8xl tracking-tightest leading-[0.9] max-w-4xl">A specialty contractor for architectural railings.</h1>
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 py-28 md:py-40 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-3"><span className="text-[11px] tracking-[0.3em] uppercase text-onyx-metal">Who we are</span></div>
        <Reveal className="md:col-span-9">
          <p className="font-display font-semibold text-2xl md:text-4xl tracking-tight leading-[1.25]">
            ONYX CONTRACTING, LLC is a US-based specialty contractor focused exclusively on architectural railing systems — multiline, glass panel, and picket. We partner with developers, general contractors, and architects to deliver railings that perform as beautifully as they look.
          </p>
          <p className="text-onyx-metal text-lg mt-8 max-w-3xl leading-relaxed">
            From grand-stair glass balustrades to cable-run terraces, we self-perform the work our reputation depends on — engineering, fabrication, and field installation under one roof.
          </p>
        </Reveal>
      </section>

      <section className="bg-onyx-black text-white py-24">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid grid-cols-2 md:grid-cols-4 gap-y-14 gap-x-8">
          {STATS.map((s, i) => (
            <Reveal key={s.l} delay={i * 0.08}>
              <div className="font-display font-extrabold text-5xl md:text-7xl tracking-tightest text-onyx-wood">{s.n}</div>
              <div className="text-white/50 text-sm mt-3">{s.l}</div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 py-28 md:py-40">
        <h2 className="font-display font-extrabold text-4xl md:text-6xl tracking-tightest mb-16">What we stand for.</h2>
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-12">
          {VALUES.map((v, i) => (
            <Reveal key={v.k} delay={i * 0.08}>
              <div className="border-t border-black/10 pt-6">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-onyx-wood text-sm">0{i + 1}</span>
                  <h3 className="font-display font-bold text-2xl tracking-tight">{v.k}</h3>
                </div>
                <p className="text-onyx-metal mt-4 leading-relaxed">{v.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-onyx-cream border-t border-black/10 py-24">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-display font-extrabold text-3xl md:text-5xl tracking-tightest">Ready to engineer your envelope?</h2>
          <Link to="/contact" className="inline-block mt-8 bg-onyx-black text-white px-10 py-4 text-[12px] tracking-[0.15em] uppercase hover:bg-onyx-wood hover:text-onyx-black transition-colors">Request a Proposal</Link>
        </div>
      </section>
    </div>
  );
}
